let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6niPY")).then(() => parcelRequire('jelzh'));